import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=3dfb61ca&"
import script from "./UserAvatar.vue?vue&type=script&lang=js&"
export * from "./UserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports